import React from 'react';

export function getLazyFacetHandler(
  data: Record<string, any[]>,
  key: string,
  results: () => Promise<any[]>,
  component: () => Promise<any>
): React.LazyExoticComponent<React.ComponentType> {
  return React.lazy(() => {
    return results()
      .then(res => {
        data[key].push(...res);
      })
      .then(() => component());
  });
}
